import * as React from "react";
import { TextField, Grid, Button } from "@mui/material";
import styles from "./invoiceSummary.module.scss";

const API_URL = process.env.API_URL;
function InvoiceSummary({ onClose }) {
  const [dates, setDates] = React.useState({ dateIn: "", dateFn: "" });
  const [error, setError] = React.useState("");

  function handleChangeDate({ target: { name, value } }) {
    setDates((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  async function getReport() {
    try {
      const downloadUrl = `${API_URL}invoice/caja-resumen?dateIn=${dates.dateIn}&dateFn=${dates.dateFn}`;
      window.open(downloadUrl, "download");
      onClose();
    } catch (error) {
      onClose();
    }
  }
  return (
    <div className={styles.invoice_summary__container}>
      {error !== "" && <p>{error}</p>}
      <p className={styles.invoice_description}>
        Favor de insertar las fechas, para el reporte de caja resumido.
      </p>
      <Grid container justify="center" spacing="4">
        <Grid item>
          <TextField
            id="date"
            label="Fecha"
            type="date"
            margin="normal"
            InputLabelProps={{ shrink: true }}
            fullWidth
            name="dateIn"
            value={dates.dateIn}
            onChange={handleChangeDate}
            error={!!error}
          />
        </Grid>
        <Grid item>
          <TextField
            id="date"
            label="Fecha"
            type="date"
            margin="normal"
            InputLabelProps={{ shrink: true }}
            fullWidth
            name="dateFn"
            value={dates.dateFn}
            onChange={handleChangeDate}
            error={!!error}
          />
        </Grid>
        <Grid container justify="center" spacing="4">
          <Grid item>
            <Button variant="contained" color="primary" onClick={getReport}>
              Generar
            </Button>
          </Grid>
          <Grid item>
            <Button onClick={onClose} color="secondary">Cancelar</Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default InvoiceSummary;
